import { ActionIcon, Group, Stack } from "@mantine/core"
import { CastsTable } from "./casts-table"
import { CastsCards } from "./casts-cards"
import { OwnerGroupTreeSelect } from "../../../../../-components/owner-tree-select"
import { IconCards, IconTable } from "@tabler/icons-react"
import { useUserLocalStorage } from "../../../../../-components/use-user-local-storage"
import { ScrollContainer } from "../../../../../../../-components/scroll-container"

interface Props {
  activityId: number
}

export function CastsTab({ activityId }: Props) {
  const [view, setView] = useUserLocalStorage<"table" | "cards">({
    key: "cast-view",
    defaultValue: "table",
  })
  const [ownerGroupFilter, setOwnerGroupFilter] = useUserLocalStorage<string[]>(
    {
      key: "owner-group-filter",
      defaultValue: [],
    }
  )

  return (
    <Stack h={"100%"}>
      <Group justify="space-between">
        <OwnerGroupTreeSelect
          w={200}
          initialCheckedState={ownerGroupFilter}
          onCheckedStateChange={(values) => setOwnerGroupFilter(values)}
        />
        <ActionIcon.Group>
          <ActionIcon
            key={"action-icon-cards"}
            disabled={view === "cards"}
            onClick={() => setView("cards")}
          >
            <IconCards />
          </ActionIcon>
          <ActionIcon
            key={"action-icon-table"}
            disabled={view === "table"}
            onClick={() => setView("table")}
          >
            <IconTable />
          </ActionIcon>
        </ActionIcon.Group>
      </Group>
      <ScrollContainer>
        {view === "table" ? (
          <CastsTable activityId={activityId} ownerGroups={ownerGroupFilter} />
        ) : (
          <CastsCards activityId={activityId} ownerGroups={ownerGroupFilter} />
        )}
      </ScrollContainer>
    </Stack>
  )
}
